import type { SelectOption } from '@/shared/ui';

export const METRIC_OPTIONS: SelectOption[] = [
  { value: 'W', label: 'Weight' },
  { value: 'V', label: 'Volume' },
  { value: 'VA', label: 'Value' },
  { value: 'C', label: 'Consignments' },
  { value: 'L', label: 'Lines' },
  { value: 'D', label: 'Dangerous' }
];

export const GROUP_BY_OPTIONS: SelectOption[] = [
  { value: 'D', label: 'Date' },
  { value: 'W', label: 'Week' },
  { value: 'L', label: 'Location' },
  { value: 'S', label: 'Subregion' },
  { value: 'R', label: 'Region' },
  { value: 'U', label: 'Organization' },
  { value: 'T', label: 'Type' },
  { value: 'P', label: 'Product' }
];

export const DATE_RANGE_OPTIONS: SelectOption[] = [
  { value: 'LW', label: 'Last Week' },
  { value: 'L2W', label: 'Last 2 Weeks' },
  { value: 'LM', label: 'Last Month' },
  { value: 'L2M', label: 'Last 2 Months' },
  { value: 'L6M', label: 'Last 6 Months' },
  { value: 'LY', label: 'Last Year' },
  { value: 'FE', label: 'All Time' },
  { value: 'CR', label: 'Custom Range' }
];

export const STATUS_OPTIONS: SelectOption[] = [
  { value: 'DI', label: 'Dispatched' },
  { value: 'RC', label: 'Received' }
];

/**
 * Group-specific options for different contexts
 */
export const TRANSPORT_GROUP_OPTIONS: SelectOption[] = [
  { value: 'D', label: 'Date' },
  { value: 'OL', label: 'Origin Location' },
  { value: 'OS', label: 'Origin Subregion' },
  { value: 'OR', label: 'Origin Region' },
  { value: 'DL', label: 'Destination' },
  { value: 'DS', label: 'Destination Subregion' },
  { value: 'DR', label: 'Destination Region' },
  { value: 'SO', label: 'Sender Org' },
  { value: 'SOT', label: 'Sender Type' },
  { value: 'P', label: 'Product' }
];
